// extracted by mini-css-extract-plugin
export default {"newsContentItemSmall":"newsFPitem_newsContentItemSmall__EKEuQ"};